import {Component, computed, input} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {UserFormField, UserFormSection, UserFormSectionFields} from '../../../models/user-form.types';

@Component({
	selector: 'dc-user-form-error',
	imports: [TranslateModule],
	styleUrl: '../user-form.styles.scss',
	template: `
		@let isInvalid = isInvalidFn();
		@if ((isInvalid && isInvalid(controlName())) || !isInvalid) {
			<div class="form-field-error">
				@let errors = parentForm().get(controlName().toString())?.errors;
				@let fieldTranslation = this.controlNameLabelTranslation$();
				@if (errors?.['required']) {
					<span class="error-message">
						{{ 'structure.form.validation.required' | translate: {field: fieldTranslation | translate} }}
					</span>
				}
				@if (errors?.['minlength']) {
					<span class="error-message">
						{{ 'structure.form.validation.minlength' | translate: {minlength: minlength(), field: fieldTranslation | translate} }}
					</span>
				}
				@if (errors?.['email']) {
					<span class="error-message">
						{{ 'structure.form.validation.pattern' | translate: {field: fieldTranslation | translate} }}
					</span>
				}
				@if (errors?.['pattern']) {
					<span class="error-message">
						{{ 'structure.form.validation.pattern' | translate: {field: fieldTranslation | translate} }}
					</span>
				}
				@if (errors?.['mismatch']) {
					<span class="error-message">
						{{ 'user.form.validation.password.mismatch' | translate }}
					</span>
				}
				@if (errors?.['requireAtLeastOneCheckbox']) {
					<span class="error-message">
						{{ 'user.form.validation.permissions.requireAtLeastOneCheckbox' | translate }}
					</span>
				}
				@for (error of Object.keys(additionalErrors()); track error) {
					@if (errors?.[error]) {
						<span class="error-message">
							{{ additionalErrors()[error] | translate }}
						</span>
					}
				}
			</div>
		}
	`,
})
export class UserFormErrorComponent<S extends UserFormSection> {
	protected readonly Object = Object;

	readonly isInvalidFn = input<(controlName: UserFormSectionFields<S>) => boolean>((_: UserFormSectionFields<S>) => true);
	readonly parentForm = input.required<FormGroup>();
	readonly controlSection = input.required<S>();
	readonly controlName = input.required<keyof UserFormField<S>>();
	readonly controlNameLabel = input<string>(null);

	readonly additionalErrors = input<Record<string, string>>({});

	protected readonly controlNameLabelTranslation$ = computed(() => {
		if (this.controlNameLabel()) return this.controlNameLabel();

		// Special cases for the renamed keys
		if (this.controlName().toString() === 'communicationPreference') {
			return 'user.form.field.communicationPreference.title';
		}
		if (this.controlName().toString() === 'dateFormat') {
			return 'user.form.field.dateFormat.title';
		}

		return 'user.form.field.' + this.controlName().toString();
	});

	readonly minlength = input<number>(2);
	readonly maxlength = input<number>(255);
}
